var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-layout',{attrs:{"column":"","pa-0":""}},[_c('v-layout',{staticClass:"terminal",attrs:{"column":"","fill-height":"","ma-0":"","pt-1":""}},[_c('div',{ref:"terminal",staticStyle:{"height":"100%"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }